import { useRecoilValue, useResetRecoilState } from 'recoil'
import { useParams } from 'react-router'
import {
  AllCheckStatus,
  CertCheckState,
  JoinTermsValue,
  PartnerListData,
  RecoilStateList,
  TelNumState,
  uiVerifyStyle,
} from 'src/recoil/common'

import useAPI from 'src/hooks/useAPI'
import PageCalling from 'src/components/common/PageCalling'
import { PartnerListType } from 'src/types/type'
import {
  CustomBtn,
  JoinSubmitWrap,
  NoticeFeeText,
  NoticeWrap,
} from 'src/styles/styledcomponent/views/Rop02/JoinSubmit'

const JoinSubmit = (props: any): JSX.Element => {
  const params = useParams()
  const { submit } = props

  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const api = useAPI('requestJoin')
  const { TelType, PhoneNum, CertNum, authKeyValue, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const ResetPhoneNum = useResetRecoilState(TelNumState)
  const ResetCertCheck = useResetRecoilState(CertCheckState)
  const ResetTermsAgree = useResetRecoilState(JoinTermsValue)
  const ResetTerms = useResetRecoilState(AllCheckStatus)
  const { cashSpace, verifyBtn, cancelBtn } = useRecoilValue(uiVerifyStyle)
  const { mutateAsync: JoinRequest, isLoading } = api.useSetMutation({
    TranID: TransId,
    Telecom: TelType,
    PNumber: PhoneNum,
    PCode: params.pcode,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData?.TermsIdx,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })
  const isJoinApiPending = submit.isVulnerableCheckPending || isLoading
  const isJoinBusy = submit.isJoinSubmitting || isJoinApiPending

  return (
    <>
      <JoinSubmitWrap>
        <PageCalling active={isJoinApiPending} />
        <CustomBtn
          className="btn_signup"
          {...verifyBtn}
          backgroundColor={verifyBtn.backgroundColor}
          onClick={() => submit.join(JoinRequest)}
          disabled={isJoinBusy}
        >
          {PartnerData.ButtonMsgAfter}
        </CustomBtn>
        <CustomBtn
          className="btn_cancel"
          {...cancelBtn}
          onClick={() => {
            ResetPhoneNum()
            ResetCertCheck()
            ResetTerms()
            ResetTermsAgree()
          }}
        >
          취소
        </CustomBtn>
      </JoinSubmitWrap>
      <NoticeWrap>
        <NoticeFeeText
          cashSpace={cashSpace}
          fontColor={PartnerData.FontColor}
          fontSize={PartnerData.FontSize}
          dangerouslySetInnerHTML={{ __html: PartnerData.NotiContent }}
        />
      </NoticeWrap>
    </>
  )
}
export default JoinSubmit
